<template>
  <div>

    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="`${url_banners_mobile}/images/mobile/banner_home.jpg`"
      ></BannerTopMobile>
    </div>

    <div class="d-flex justify-content-center">
      <RegisterForm :redirect="redirect"></RegisterForm>
    </div>
  </div>
</template>

<script>
import RegisterForm from '@/components/store/RegisterForm'

export default {
  components: { RegisterForm },
  data() {
    return {
      url_banners_mobile: process.env.VUE_APP_URL_FILES,
      redirect: '/'
    }
  },
  mounted() {
    if (this.$route.query.ref) {
      if (this.$route.query.ref == 'suscripcion') {
        this.redirect = '/procesar-suscripcion'
      }
      if (this.$route.query.ref == 'tienda') {
        this.redirect = '/procesar-pago'
      }
    }
  }
}
</script>
